<template>
  <StudioMultiSelect
    v-model="itemsSelected"
    :searchable="true"
    :items="selectItems"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{index}">
      <span
        v-if="index === minimumFilterView"
        class="grey--text caption"
      >
        {{ itemsSelected.length }} {{ message }}
      </span>
    </template>
  </StudioMultiSelect>
</template>

<script>
import statusModel from '@/mixins/status-model';
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';

export default {
  name: 'StatusFilter',
  components: {
    StudioMultiSelect,
  },
  mixins: [
    statusModel,
  ],
  props: {
    value: {
      type: Object,
      default: () => {
      },
    },
    channels: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Status',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      placeholder: 'Indiferente',
      minimumFilterView: 0,
    };
  },
  computed: {
    itemsSelected: {
      get() {
        if (this.value && this.value.value) {
          return this.value.value;
        }

        return [];
      },
      set(newValue) {
        let newTypes = newValue;

        if (!newValue?.length) {
          return this.$emit('input', undefined);
        }

        if (typeof (newValue[0]) === 'object') {
          newTypes = newValue.map(v => v && v.value);
        }

        this.$emit('input', {
          value: newTypes,
        });
      },
    },
    selectItems() {
      return this.getAll().map(status => {
        return {
          text: status.name,
          value: status.name,
        };
      });
    },
    message() {
      return this.itemsSelected.length - this.minimumFilterView === 1 ? 'selecionado' : 'selecionados';
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
